import AddrAsiakas from "./AddrAsiakas";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { asiakas_fetch } from "src/data/asiakas/AsiakasFunctions";
import { useUserData } from "src/context/userContext";
import ProgressCirc from "src/components/layout/Progress/ProgressCirc";
import userAuthClass from "src/data/auth/userAuthClass";

export default function AddrAsiakasCore() {
  const [asiakas, setAsiakas] = useState(null);
  const { user, token, ownerAsiakasId, userAsiakas } = useUserData();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [asiakasAuth, setAsiakasAuth] = useState();

  let params = useParams();
  let asiakasId = parseInt(params.asiakasId);

  useEffect(() => {
    const asyncFunc = async () => {
      if (asiakasId) {
        const fetchResult = await asiakas_fetch(user, asiakasId, token, null, ownerAsiakasId);
        const _asiakas = fetchResult.globalAsiakas;
        if (_asiakas != null) {
          setAsiakas(_asiakas);
        } else {
          setIsError(true);
        }
        const a = new userAuthClass(user, userAsiakas);
        a.init(_asiakas);
        setAsiakasAuth(a);
      } else setAsiakas(null);
      setIsLoading(false);
    };
    asyncFunc();
  }, [asiakasId, ownerAsiakasId]);

  if (asiakasId === 0) return <>asiakasId===0</>;
  if (isLoading) return <ProgressCirc />;
  if (isError) return <>isError</>;
  if (!asiakas) return <>asiakas not found</>;
  if (!asiakasAuth.asiakas.read) return <>Access denied at AddrAsiakasCore</>;

  return <AddrAsiakas asiakas={asiakas} />;
}
